import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useReducer,
} from 'react';
import _find from 'lodash/find';

// import history from 'utils/history';
import useDeviceDetect from 'utils/useDeviceDetect';
import { appHelper } from 'appCapacitor/helpers';


/**
 * Context for Theme
 */
const initState = {
  mode: "light",
  hasValueModalOnSaveChanges: false,
  isOpenModalOnSaveChanges: false,
  savedModalOnSaveChanges: false,
  canceledModalOnSaveChanges: false,
  loading: false,
  error: false,
};

const reducer = (s, v) => ({ ...s, ...v });

const ThemeStateContext = createContext();
const ThemeDispatchContext = createContext();

export const useStateTheme = () => {
  const theme = useContext(ThemeStateContext);
  if (!theme) {
    throw Error(
      'useStateTheme must be call withing ThemeContextProvider',
    );
  }
  return theme;
};

export const useDispatchTheme = () => {
  const setTheme = useContext(ThemeDispatchContext);
  if (!setTheme) {
    throw Error(
      'useDispatchTheme must be call withing ThemeContextProvider',
    );
  }
  return setTheme;
};

export const ThemeContextProvider = ({ children }) => {
  const [theme, setTheme] = useReducer(reducer, initState);

  const { isMobile } = useDeviceDetect();

  // this useEffect runs only the first render
  useEffect(() => {
    setTheme(prev => ({ ...prev, isMobile }));
  }, []);

  const useAdd = data => {
    const newData = { ...theme, ...data };
    setTheme(newData);
    return newData;
  };

  const onOpenOnSaveModalCallback = useCallback(() => {
    !!!theme?.isOpenModalOnSaveChanges &&
      !!theme?.hasValueModalOnSaveChanges &&
      useAdd({
        isOpenModalOnSaveChanges: true,
        savedModalOnSaveChanges: false,
        canceledModalOnSaveChanges: false,
      });
  }, [theme?.isOpenModalOnSaveChanges, theme?.hasValueModalOnSaveChanges]);

  const themeData = {
    ...theme,
    useAdd,
    onOpenOnSaveModalCallback
  };

  return (
    <ThemeStateContext.Provider value={themeData}>
      <ThemeDispatchContext.Provider value={setTheme}>
        {children}
      </ThemeDispatchContext.Provider>
    </ThemeStateContext.Provider>
  );
};

export const withTheme = Component => props => (
  <ThemeStateContext.Consumer>
    {store => <Component theme={store} {...props} />}
  </ThemeStateContext.Consumer>
);